var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("fieldset", { staticClass: "blocoFieldset" }, [
      _c("legend", [
        _c(
          "a",
          {
            staticClass: "btn",
            attrs: { role: "button", "aria-expanded": "false" },
            on: {
              click: function($event) {
                _vm.showContent = !_vm.showContent
              }
            }
          },
          [
            _c("i", {
              staticClass: "far fa-caret-square-up",
              class: _vm.showContent ? "collapse.show" : "collapse"
            }),
            _c("i", {
              staticClass: "far fa-caret-square-down",
              class: _vm.showContent ? "collapse" : "collapse.show"
            })
          ]
        ),
        _vm._v("\n            Benefícios\n        ")
      ]),
      _c(
        "div",
        { class: _vm.showContent ? "collapse.show" : "collapse" },
        [
          _c(
            "b-row",
            { staticStyle: { "margin-left": "25px" } },
            [
              _c(
                "b-col",
                { attrs: { xs: "12", sm: "12", md: "12", lg: "12", xl: "12" } },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "text-label", attrs: { label: "" } },
                    _vm._l(_vm.beneficiosSelecionados, function(ben) {
                      return _c(
                        "div",
                        { key: ben.id, staticClass: "multiselect__tags-wrap" },
                        [
                          _c(
                            "span",
                            { staticClass: "multiselect__single" },
                            [
                              _c("span", [_vm._v(_vm._s(ben.descricao))]),
                              !_vm.isExibirProp
                                ? _c(
                                    "b-link",
                                    {
                                      attrs: { title: "Remover" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removerBeneficio(ben)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "multiselect__tag-icon",
                                        attrs: {
                                          "aria-hidden": "true",
                                          tabindex: "1"
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }